import React from 'react';
import { Button, Modal } from 'react-bootstrap';

const SelectionRemoveModal = ({ show, handleClose, handleConfirm, text }) => {
  return (
    <Modal show={show} onHide={handleClose} className="modal-delete">
      <div className="warning-content">
        <div className="warningOuter alertMsg">
          <div className="alertImg">
            <img src="../assets/images/caution.png" alt="Delete Record"></img>
          </div>
          <div className="warningText">{text}</div>
        </div>
        <div className=" mt-2">
          <button type="button" className="btn btn-outline-primary me-2" onClick={handleClose}>
            Cancel
          </button>
          <Button className="btn btn-primary" onClick={handleConfirm}>
            Proceed!
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SelectionRemoveModal;
